module.exports = __webpack_public_path__ + "static/media/isaac_wen.31a7c28a.png";